/* eslint-disable @typescript-eslint/no-explicit-any */
export const updateTrackingProperties = (data: any, componentname: string) => {
  const cardsArr: any = [];
  Object.keys(data.cqItems).forEach(key => {
    const item = data.cqItems[key][':items'][componentname];
    const { header, ctaLinkText, trackingProperties } = item;
    if (item && item.trackingProperties) {
      item.trackingProperties.location = header || trackingProperties?.location;
      item.trackingProperties.cardLocation = header || trackingProperties?.cardLocation;
      item.trackingProperties.description = ctaLinkText || trackingProperties?.description;
      item.trackingProperties.trackingDescription = ctaLinkText || trackingProperties?.trackingDescription;
    }
    cardsArr.push(item);
  });
  return cardsArr;
};

export const getLeisureComponent = (innerComp: string) => {
  console.log('Destination innerComp >> ', innerComp);
  // leisure
  if (innerComp === 'DestinationsAccordion') {
    return import(`../organisms/DestinationAccordionContainerEnhanced/index`).then(module => ({
      default: module['DestinationAccordionContainerEnhanced'],
    }));
  }

  return import(`../../../mi-common-static-components/src/organisms/${innerComp}/index`).then(module => ({
    default: module[innerComp],
  }));
};

export const findComponentByType: (node: any, type: string) => any | null = function findComponentByTypeInternal(
  node: any,
  type: string
): any | null {
  if (!node) return null;

  // Handle arrays
  if (Array.isArray(node)) {
    for (const item of node) {
      const found = findComponentByTypeInternal(item, type);
      if (found) return found;
    }
    return null;
  }

  // Only objects from here
  if (typeof node !== 'object') return null;

  // Match component type
  if (node[':type'] === type) {
    return node;
  }

  // Traverse object properties
  for (const key of Object.keys(node)) {
    const found = findComponentByTypeInternal(node[key], type);
    if (found) return found;
  }

  return null;
};

export const isCityDestination = (destinationMetaData: any) => {
  return (
    !destinationMetaData?.isCountryEnabled &&
    !isCountryCodeOverridden(destinationMetaData) &&
    !destinationMetaData?.isStateEnabled
  );
};
const isCountryCodeOverridden = (destinationMetaData?: any) => {
  return destinationMetaData?.countryCodeOverride ? true : false;
};
export const getCountryCode = (destinationMetaData: any) => {
  return destinationMetaData?.countryCodeOverride ?? destinationMetaData?.countryCode;
};
